module.exports = __webpack_public_path__ + "img/2P.3ca8ac4e.png";